if ( typeof MainHeader !== 'function' ) {

	class MainHeader extends HTMLElement {

		constructor(){
			super();
			this.mount();
		}

		mount(){

			/* -- > DRAWERS < -- */

			document.querySelectorAll('#main > div').forEach(elm=>{
				if ( ! elm.classList.contains('no-inert') ) {
					elm.setAttribute('data-js-inert', '');
				}
			})
			window.inertElems = document.querySelectorAll('[data-js-inert]');

			// Sticky header

			if ( this.hasAttribute('data-sticky-header') ) {

				const stickyHeader = document.createElement('div');
				stickyHeader.classList = 'sticky-header site-header'
				stickyHeader.innerHTML = `<div class="header__bottom header-container container--large portable-hide">
					${this.querySelector('.header__bottom').innerHTML}
					<div style="display:flex;gap:15px;">
						${this.querySelector('.area--custom-icon') ? this.querySelector('.area--custom-icon').outerHTML : ''}
						${this.querySelector('.area--search').outerHTML}
						${this.querySelector('.area--cart').outerHTML}
					</div>
				</div>
				<div class="site-header element--hide-on-portable-plus">
					${this.querySelector('.header-container--top').innerHTML}
				</div>`;
				document.body.append(stickyHeader);
				stickyHeader.querySelectorAll('[id]').forEach(elm=>{
					elm.id = `${elm.id}-sticky`;
				})
				stickyHeader.querySelectorAll('.site-nav [aria-controls]').forEach(elm=>{
					elm.setAttribute('aria-controls', `${elm.getAttribute('aria-controls')}-sticky`);
				});

				window.lst = window.scrollY;
				window.lhp = 0;

				const stickyHeaderDeskBound = this.querySelector('.header__bottom');
				const stickyHeaderMobileBound = this.querySelector('.header__top');

				this.SCROLL_StickyHelper = () =>{

					var st = window.scrollY;
					if ( ( st <= 0 || ( window.innerWidth >= 1024 ? stickyHeaderDeskBound.getBoundingClientRect().top >= 0 : stickyHeaderMobileBound.getBoundingClientRect().top >= 0 ) ) && stickyHeader.classList.contains('show') ) {
						stickyHeader.classList.remove('show');
						return;
					}

					if ( st < 0 || Math.abs(lst - st) <= 5 )
						return;	

					if ( st > window.lhp ) {

						if ( st == 0 && stickyHeader.classList.contains('show') ) {

							stickyHeader.classList.remove('show');

						} else if ( st <= lst && ! stickyHeader.classList.contains('show') ) {

							window.lhp = stickyHeader.offsetTop;
							stickyHeader.classList.add('show');

						} else if ( st > lst && stickyHeader.classList.contains('show') ) {
							stickyHeader.classList.remove('show');
						}

					} 

					window.lst = st;

				}

				window.addEventListener('scroll', this.SCROLL_StickyHelper, {passive:true});
				
			}

			// drawer connections

			document.querySelectorAll('[data-js-sidebar-handle]').forEach(elm => {
				if ( elm.hasAttribute('aria-controls') ) {
					const elmSidebar = document.getElementById(elm.getAttribute('aria-controls'));
					elm.addEventListener('click', e=>{
						e.preventDefault();
						elm.setAttribute('aria-expanded', 'true');
						elmSidebar.show();
					})
					elm.addEventListener('keyup', e=>{
						if ( e.keyCode == window.KEYCODES.RETURN ) {
							elm.setAttribute('aria-expanded', 'true');
							elmSidebar.show();
							elmSidebar.querySelector('[data-js-close]').focus();
						}
					})
				}
			});
			if ( this.classList.contains('site-header--alignment-left') ) {
				document.getElementById('site-search-sidebar').classList.remove('sidebar--left');
				document.getElementById('site-search-sidebar').classList.add('sidebar--right');
			}
			
			// closing drawers

			document.querySelectorAll('sidebar-drawer [data-js-close]').forEach(elm=>{
				elm.addEventListener('click', e=>{
					e.preventDefault();
					if ( e.target.closest('.sidebar').classList.contains('sidebar--opened') ) {
						e.target.closest('.sidebar').hide();
					}
				});
			});
			document.querySelector('.site-overlay').addEventListener('click', ()=>{
				if ( document.querySelector('.sidebar--opened') ) {
					document.querySelector('.sidebar--opened').hide();
				}
			});
			document.addEventListener('keydown', e=>{
				if ( e.keyCode == window.KEYCODES.ESC ) {
					if ( document.querySelector('.sidebar--opened') ) {
						document.querySelector('.sidebar--opened').hide();
					}
				}
			});

			// resizing drawers

			const rootHeight = document.getElementById('root-height');
			this.RESIZE_SidebarHelper = debounce(()=>{
				rootHeight.innerHTML = `:root {
					--window-height: ${window.innerHeight}px;
					--window-width: ${document.body.clientWidth}px;
				}`;
			}, 200);
			window.addEventListener('resize', this.RESIZE_SidebarHelper);
			rootHeight.innerHTML = `:root {
				--window-height: ${window.innerHeight}px;
				--window-width: ${document.body.clientWidth}px;
			}`;
			document.body.classList.add('header-loaded');

			// submenu masonry

			document.querySelectorAll('.site-nav.style--classic .submenu-masonry').forEach(elm=>{
				// submenu-masonry--auto opts out of Macy so CSS grid can use content-width, packed columns
				if ( Macy && !elm.classList.contains('submenu-masonry--auto') ) {
					const submenuMacy = new Macy({
						container: elm,
						columns: parseInt(elm.getAttribute('data-columns')),
						margin: 30
					});
					setTimeout(()=>{
						submenuMacy.reInit();
					}, 100);
				}

			});

			// predictive search

			if ( JSON.parse(document.getElementById('shopify-features').text).predictiveSearch ) {

				// predictive search (sidebar)

				document.querySelectorAll('[data-js-open-search-drawer').forEach(elm=>{
					elm.addEventListener('click', e=>{
						e.preventDefault();
						if ( ! document.body.classList.contains('predictive-script-loaded') ) {
							document.body.classList.add('predictive-script-loaded')
							const predictiveSearchJS = document.createElement('script');
							predictiveSearchJS.src = KROWN.settings.predictive_search_script;
							document.head.appendChild(predictiveSearchJS); 
						}
						setTimeout(()=>{
							document.querySelector('#search-form-sidebar').focus();
						}, 10)
					});
				});

			} else {

				this.querySelector('search-form').addEventListener('click', e=>{
					e.preventDefault();
					window.location.href = KROWN.settings.routes.search_url;
				});

			}

			document.querySelectorAll('.style--classic .has-submenu, .style--classic .has-babymenu').forEach(elm=>{
				if ( ! elm.classList.contains('mega-link') ) {
					elm.addEventListener('touchstart', e=>{
						elm.firstElementChild.style.pointerEvents = 'none';
						elm.classList.toggle('focus');
					})
				}
			})

			// tab navigation for the menu

			document.querySelectorAll('.site-nav.style--classic .has-submenu > a').forEach(childEl=>{

				const elm = childEl.parentNode;

				elm.addEventListener('keydown', e=>{

					if ( e.keyCode == window.KEYCODES.RETURN ) {
						if ( ! e.target.classList.contains('no-focus-link') ) {
							e.preventDefault();
						}
						if ( ! elm.classList.contains('focus') ) {
							elm.classList.add('focus');
							elm.setAttribute('aria-expanded', 'true');
						} else if ( document.activeElement.parentNode.classList.contains('has-submenu') && elm.classList.contains('focus') ) {
							elm.classList.remove('focus');
							elm.setAttribute('aria-expanded', 'true');
						}
					}
				});	
				
				if ( elm.querySelector('.submenu-holder > li:last-child a') ) {
					elm.querySelector('.submenu-holder > li:last-child a').addEventListener('focusout', e=>{
						if ( elm.classList.contains('focus') ) {
							elm.classList.remove('focus');
							elm.setAttribute('aria-expanded', 'false');
						}
					});
				}

			});

			document.querySelectorAll('.site-nav.style--classic .has-babymenu:not(.mega-link) > a').forEach(childEl=>{	

				const elm = childEl.parentNode;

				elm.addEventListener('keydown', e=>{
					if ( e.keyCode == window.KEYCODES.RETURN ) {
						if ( ! e.target.classList.contains('no-focus-link') ) {
							e.preventDefault();
						}
						if ( ! elm.classList.contains('focus') ) {
							elm.classList.add('focus');
							elm.setAttribute('aria-expanded', 'true');
						} else {
							elm.classList.remove('focus');
							elm.setAttribute('aria-expanded', 'false');
						}
					}
				});

				if ( elm.querySelector('.babymenu li:last-child a') ) {
					elm.querySelector('.babymenu li:last-child a').addEventListener('focusout', e=>{
						if ( elm.parentNode.classList.contains('focus') ) {
							elm.parentNode.classList.remove('focus');
							elm.parentNode.setAttribute('aria-expanded', 'false');
						}
					});
				}

			})

		}

		unmount(){
			window.removeEventListener('resize', this.RESIZE_SidebarHelper);
		}

	}
	
  if ( typeof customElements.get('main-header') == 'undefined' ) {
		customElements.define('main-header', MainHeader);
	}

}

if ( typeof SidebarDrawer !== 'function' ) {

	class SidebarDrawer extends HTMLElement {

		constructor(){
			super();
			this.querySelector('[data-js-close]').addEventListener('click', ()=>{
				this.hide();
			});
			document.addEventListener('keydown', e=>{
				if ( e.keyCode == window.KEYCODES.ESC ) {
					const openedSidebar = document.querySelector('sidebar-drawer.sidebar--opened');
					if ( openedSidebar ){
						openedSidebar.hide();
					}
				}
			});
		}

		/* 
			* generic hide/show functions 
		*/

		show(){

			this._opened = true;
			document.body.classList.add('sidebar-opened');
			if ( this.classList.contains('sidebar--right') ) {
				document.body.classList.add('sidebar-opened--right');
			} else if ( this.classList.contains('sidebar--left') ) {
				document.body.classList.add('sidebar-opened--left');
			}
			if ( this.id == 'site-cart-sidebar' && document.getElementById('cart-recommendations-sidebar') ) {
				setTimeout(()=>{
					document.querySelector('#cart-recommendations-sidebar css-slider')?.resetSlider();
				}, 10);
			}
			this.style.display = 'grid';
			setTimeout(()=>{
				this.classList.add('sidebar--opened');
				window.inertElems.forEach(elm=>{
					elm.setAttribute('inert', '');
				})
			}, 15);

		}

		hide(){

			this._opened = false;
			this.classList.remove('sidebar--opened');

			document.body.classList.remove('sidebar-opened');
			document.body.classList.remove('sidebar-opened--left');
			document.body.classList.remove('sidebar-opened--right');
			window.inertElems.forEach(elm=>{
				elm.removeAttribute('inert');
			})

			document.querySelector(`[aria-controls="${this.id}"]`)?.setAttribute('aria-expanded', 'false');

			setTimeout(()=>{
				this.style.display = 'none';
			}, 501);

		}

	}


  if ( typeof customElements.get('sidebar-drawer') == 'undefined' ) {
		customElements.define('sidebar-drawer', SidebarDrawer);
	}

}

if ( typeof MobileNavigation !== 'function' ) {
		
	class MobileNavigation extends HTMLElement {

		constructor() {

			super();

			this._openedFirstSubmenu = false;
			this._openedSecondSubmenu = false;
			this._openRows = [];

			/*
				KPS: in the drawer a section row has two distinct targets —

					label   -> plain link, goes to the section's own page
					chevron -> steps INTO the section's sub-links

				The theme used to swallow the whole row (every tap opened the panel and the
				section page was unreachable from the drawer). Handlers are delegated from
				the element rather than bound per <a> in the constructor, so rows the
				constructor never saw — drawer re-rendered by the theme editor, markup
				swapped in later — behave the same way.
			*/
			this.addEventListener('click', e=>{

				const anchor = e.target.closest('a');
				if ( ! anchor || ! this.contains(anchor) ) return;

				// Back row — step out one level.
				if ( anchor.closest('.submenu-back') ) {
					e.preventDefault();
					this._closeSubmenu(anchor);
					return;
				}

				// Only the row's own link carries a panel — links nested deeper (mega-menu
				// product cards, promotion images, CTA buttons) are ordinary links.
				const row = anchor.parentElement;
				if ( ! row || anchor !== row.querySelector(':scope > a') ) return;

				const level = this._submenuLevel(row);
				if ( ! level ) return;

				/*
					Chevron opens the panel. The label navigates — unless the row has no page
					to navigate to (mega-menu headings render their link without an href), in
					which case the whole row opens the panel so the section stays reachable.
				*/
				const href = anchor.getAttribute('href');
				if ( ! e.target.closest('.icon') && href && href !== '#' ) return;

				e.preventDefault();
				this._openSubmenu(row, level);

			});

			/*
				The chevron sits inside the link, so it cannot take focus of its own without
				nesting one interactive element in another. ArrowRight opens the panel the
				chevron would open — the direction the panel slides in from — which keeps the
				sub-links reachable from the keyboard now that Enter follows the link.
			*/
			this.addEventListener('keydown', e=>{

				if ( e.key !== 'ArrowRight' ) return;

				const anchor = e.target.closest && e.target.closest('a');
				if ( ! anchor || ! this.contains(anchor) || anchor.closest('.submenu-back') ) return;

				const row = anchor.parentElement;
				if ( ! row || anchor !== row.querySelector(':scope > a') ) return;

				const level = this._submenuLevel(row);
				if ( ! level ) return;

				e.preventDefault();
				this._openSubmenu(row, level);

			});

		}

		/*
			Which panel a row opens: 1 = submenu, 2 = babymenu, 0 = plain link. The class
			is the theme's own marker; the child-panel check is a fallback so a row that
			carries a panel without the class still opens rather than navigating away.
		*/
		_submenuLevel(row){
			if ( row.classList.contains('has-submenu') || row.querySelector(':scope > .submenu') ) return 1;
			if ( row.classList.contains('has-babymenu') || row.querySelector(':scope > .babymenu') ) return 2;
			return 0;
		}
		_openSubmenu(row, level){

			/*
				Remember the exact row per level. Measuring by `.opened` alone would pick the
				first match in document order, which for ~300ms after a Back is the row still
				sliding out rather than the one just opened. It also gives the outgoing row a
				name, so it can be closed before the new one opens — tapping section B's
				chevron while section A's panel is still sliding in would otherwise leave both
				panels `display:block` on top of each other, with A stuck open for good.
			*/
			const previous = this._openRows[level - 1];
			if ( previous && previous !== row ) {
				previous.classList.remove('opened');
				previous.setAttribute('aria-expanded', 'false');
			}
			this._openRows[level - 1] = row;

			if ( level == 1 && ! this._openedFirstSubmenu ) {
				this._openedFirstSubmenu = true;
				this.classList.add('opened-first-submenu');
				this.closest('sidebar-drawer')?.scrollTo({top: 0});
			} else if ( level == 2 && ! this._openedSecondSubmenu ) {
				this._openedSecondSubmenu = true;
				this.classList.add('opened-second-submenu');
				this.closest('sidebar-drawer')?.scrollTo({top: 0});
			}

			row.classList.add('opened');
			row.setAttribute('aria-expanded', 'true');
			this._resizeContainer();

		}

		_closeSubmenu(anchor){

			let closed = null;
			let slot = -1;

			if ( this._openedSecondSubmenu ) {
				slot = 1;
				this._openedSecondSubmenu = false;
				this.classList.remove('opened-second-submenu');
				closed = this._openRows[1];
				this._openRows[1] = null;
				this._resizeContainer();
			} else if ( this._openedFirstSubmenu ) {
				slot = 0;
				this._openedFirstSubmenu = false;
				this.classList.remove('opened-first-submenu');
				closed = this._openRows[0];
				this._openRows[0] = null;
				this._resizeContainer(true);
			}

			this.closest('sidebar-drawer')?.scrollTo({top: 0});

			/*
				The row stays `.opened` until the slide-out finishes, then hides. If the same
				chevron is tapped again inside that window the row is already open again, so
				the stale timer must not strip the class back off — that would leave the panel
				slid in but empty, with no way back.
			*/
			const opened = closed || anchor.closest('li.opened');
			setTimeout(()=>{
				if ( ! opened || this._openRows[slot] === opened ) return;
				opened.classList.remove('opened');
				opened.setAttribute('aria-expanded', 'false');
			}, 301);

		}

		_resizeContainer(main=false){
			if ( main ) {
				this.style.height = `auto`;
				return;
			}
			let panel = null;
			if ( this._openedSecondSubmenu ) {
				panel = this._openRows[1]?.querySelector(':scope > .babymenu');
			} else if ( this._openedFirstSubmenu ) {
				panel = this._openRows[0]?.querySelector(':scope > .submenu');
			}
			// Missing panel falls back to auto — never to a 0px, collapsed drawer.
			this.style.height = panel ? `${panel.scrollHeight}px` : `auto`;
		}

	}

  if ( typeof customElements.get('mobile-navigation') == 'undefined' ) {
		customElements.define('mobile-navigation', MobileNavigation);
	}

}